import Slider from './Slider.component';

export default Slider;